<template>
  <div class="">
    <div class="bg-float-default-low px-56 py-24">
      FAQ Search

      <div class="mt-8 h-56 border"></div>
    </div>
  </div>
</template>
